import React from 'react';
import {StaticQuery, graphql} from 'gatsby';
import PriceTableContainer from './PriceTableContainer';

const PriceTableStaticQueryWrapper = ({
    slot,
}) => {
    return (
        <StaticQuery
            query={
                graphql`
                query PriceTableData {
                    allPriceTable {
                        nodes {
                            FundId
                            FundName
                            FundShortName
                            DateCreated
                            FundStatus
                            FundYield
                            IsDisplayed
                            IsInvestmentSeries
                            Movement
                            PriceDate
                            SellPrice
                        }
                    }
                }`
            }
            render={data => <PriceTableContainer slot={slot} data={data}/>}
        />
    )
}

export default PriceTableStaticQueryWrapper;
